import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { GrupoUsuariosService } from "app/main/a2w/supervisor/restricoes-permissoes/grupo-usuarios/grupo-usuarios.service";
import { UserDTO } from "app/main/a2w/supervisor/restricoes-permissoes/usuario/usuario.model";
import { ConfirmDeleteComponent } from "app/shared/confirm-delete/confirm-delete.component";
import { MatSnackBarConfigComponent } from "app/shared/matSnackBarConfig/matSnackBarConfig.component";
import { UsuarioService } from "app/shared/usuario.service";
import { AuthenticationService } from "./authentication.service";
import { Functions } from "./functions";
import { PermissionModulesService } from "./permission-modules.service";
import { DocumentosService } from "app/main/a2w/assinaturas/termos-privacidade/documentos.service";
@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate, CanActivateChild {
    rotaDefault = "pages/auth/login-2";

    controlePorGrupo = true; // true
    matSnackBarConf: any;
    confirmDeleteDialogRef: MatDialogRef<ConfirmDeleteComponent>;

    excessoes: any[] = ["meu-perfil"];

    private readonly INTERVALO_15_MIN = 15 * 60 * 1000;
    private lastUpdate: number = 0;
    private updating = false;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private _modules: PermissionModulesService,
        private _groupUsersService: GrupoUsuariosService,
        private _usuarioService: UsuarioService,
        private _functions: Functions,
        private _matSnackBar: MatSnackBar,
        private _matDialog: MatDialog,
        private _documentosService: DocumentosService,
    ) {
        this.matSnackBarConf = new MatSnackBarConfigComponent();
        const saved = localStorage.getItem("lastAccessUpdate");
        this.lastUpdate = saved ? +saved : 0;
    }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            if (currentUser.userDetails != undefined) {
                this._functions.validaLoginAtivo();

                if (
                    !state.url.startsWith("/a2w/assinaturas") &&
                    (await this.temTermoPendente())
                ) {
                    this.router.navigate([
                        "/a2w/assinaturas/termos-privacidade",
                    ]);
                    return false;
                }

                // Verifica login!!!!!!!!!!!!
                this.validaAcessoLogin(state.url);


                if (!this.controlePorGrupo) {
                    return true;
                }
                if (this._modules.getModulesPermitidos().length > 0) {
                    if (
                        this._modules
                            .getModulesPermitidos()
                            .filter((x) =>
                                x.route.split("/").includes(route.url[0].path),
                            ).length > 0 ||
                        this.excessoes.filter((x) => x == route.url[0].path)
                            .length > 0
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    // por refresh a lista de permissões e perdeu

                    const res = await this._groupUsersService.listPermissions(
                        currentUser.userDetails.userGroupId,
                    ); // .then(res=>{

                    if (res) {
                        for (const item of res) {
                            if (item.canRead || item.canWrite) {
                                this._modules.setPermissionEscrita(
                                    item.companySystemModuleItemId,
                                    item.canWrite,
                                );
                                this._modules.setPermissionLeitura(
                                    item.companySystemModuleItemId,
                                    item.canRead,
                                );
                            }
                        }

                        if (this._modules.getModulesPermitidos().length > 0) {
                            if (
                                this._modules
                                    .getModulesPermitidos()
                                    .filter((x) =>
                                        x.route
                                            .split("/")
                                            .includes(route.url[0].path),
                                    ).length > 0
                            ) {
                                this._modules.updateNavigation();
                                return true;
                            } else {
                                this.authenticationService.logout();
                            }
                        } else {
                            return false;
                        }
                    }
                    // });
                }
            } else {
                this.authenticationService.logout();
            }
        }

        this.router.navigate(
            [this.rotaDefault],
        );
        return false;
    }

    async canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            this._functions.validaLoginAtivo();

            if (
                !state.url.startsWith("/a2w/assinaturas") &&
                (await this.temTermoPendente())
            ) {
                this.router.navigate([
                    "/a2w/assinaturas/termos-privacidade",
                ]);
                return false;
            }

            this.validaAcessoLogin(state.url);
            return true;
        }

        this.router.navigate(
            [this.rotaDefault]
        );
        return false;
    }

    async canLoad() {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            this._functions.validaLoginAtivo();
            return true;
        }
        this.router.navigate(
            [this.rotaDefault] /*, { queryParams: { returnUrl: state.url } }*/,
        );
        return false;
    }

    validaAcessoLogin(urlDestino: string, token?: string) {
        this.authenticationService.validaAcesso(token).then((res) => {
            switch (res.motivo) {
                case "USUARIO_INATIVO":
                    this.abrirModalConfirmacao(
                        res.message ||
                            "Seu usuário está inativo. Procure o administrador da sua conta.",
                        "Atenção!!!",
                        () => this.deslogar(),
                    );
                    break;

                case "TOKEN_INVALIDO":
                    this.abrirModalConfirmacao(
                        "O seu usuário acabou de ser utilizado para login a partir de outro navegador. Você será desconectado!. Para conectar novamente é necessário efetuar novo login.",
                        "Atenção!!!",
                        () => this.deslogar(),
                    );
                    break;

                case "TERMO_PENDENTE":
                    if (
                        !urlDestino.startsWith(
                            "/a2w/assinaturas/termos-privacidade",
                        )
                    ) {
                        this.abrirModalConfirmacao(
                            res.message ||
                                "Há uma nova versão dos Termos de Uso. Leia e aceite para continuar.",
                            "Atenção!!!",
                            () => {
                                const user = this.authenticationService.currentUserValue;
                                user.userDetails.dataAceiteTermos = null;
                                user.userDetails.termoPendente = true;
                                user.userDetails.versaoVigente = res.versaoVigente ?? null;
                                this.authenticationService.setCurrentUserSubject(user);

                                // FORÇA O GUARD A BUSCAR A SITUAÇÃO DE NOVO
                                this._documentosService.limparSituacao();
                                this.router.navigate([
                                    "/a2w/assinaturas/termos-privacidade",
                                ]);
                            },
                        );
                    }
                    break;

                // ERRO DO SERVIDOR (OU MOTIVO SÓ DO MOBILE) NÃO DESLOGA O USUÁRIO
                case "ERRO_INTERNO":
                case "VERSAO_APP_NAO_INFORMADA":
                case "VERSAO_APP_DESATUALIZADA":
                    break;

                default:
                    this.atualizaUltimoAcesso();
            }
        });
    }

    private deslogar(): void {
        this.authenticationService.logout();
        this.router.navigate(["/pages/auth/login-2"]);
    }

    abrirModalConfirmacao(
        mensagem: string,
        titulo: string,
        callback: () => void,
    ) {
        const isDialogOpen = this._matDialog.openDialogs.some(
            (dialog) =>
                dialog.componentInstance instanceof ConfirmDeleteComponent,
        );

        if (!isDialogOpen) {
            this.confirmDeleteDialogRef = this._matDialog.open(
                ConfirmDeleteComponent,
                {
                    disableClose: false,
                },
            );

            this.confirmDeleteDialogRef.componentInstance.confirmTitle = titulo;
            this.confirmDeleteDialogRef.componentInstance.confirmMessage = mensagem;
            this.confirmDeleteDialogRef.componentInstance.estiloGreen = true;
            this.confirmDeleteDialogRef.componentInstance.naoExibeCancel = true;
            this.confirmDeleteDialogRef.componentInstance.textBtnConfirm = "OK";
            this.confirmDeleteDialogRef.componentInstance.exibeIconCancel = false;

            this.confirmDeleteDialogRef.afterClosed().subscribe((result) => {
                callback();
            });
        }
    }

    private async temTermoPendente(): Promise<boolean> {
        try {
            const situacao = await this._documentosService
                .getSituacao()
                .toPromise();
            return situacao.termoPendente;
        } catch {
            return !this.authenticationService.currentUserValue?.userDetails
                ?.dataAceiteTermos;
        }
    }

    private deveAtualizarPorUsuario(): boolean {
        const usuario =
            this.authenticationService.currentUserValue?.userDetails;
        if (!usuario?.ultimoAcessoWeb) return true;
        const ultimoAcesso = new Date(usuario.ultimoAcessoWeb).getTime();
        const agora = Date.now();
        return agora - ultimoAcesso > this.INTERVALO_15_MIN;
    }

    private deveAtualizar(): boolean {
        const agora = Date.now();
        return agora - this.lastUpdate > this.INTERVALO_15_MIN;
    }

    private podeAtualizar(): boolean {
        return this.deveAtualizar() && this.deveAtualizarPorUsuario();
    }

    async atualizaUltimoAcesso() {
        if (!this.authenticationService.currentUserValue) return;
        if (this.updating) return;
        if (!this.podeAtualizar()) return;
        this.updating = true;

        try {
            const usuario =
                this.authenticationService?.currentUserValue?.userDetails;
            const userId =
                this.authenticationService?.currentUserValue?.userDetails
                    ?.userId;
            const agora = new Date();
            await this._usuarioService.atualizaAcesso(userId);

            this.lastUpdate = Date.now();
            localStorage.setItem(
                "lastAccessUpdate",
                this.lastUpdate.toString(),
            );
            usuario.ultimoAcessoWeb = agora;
        } finally {
            this.updating = false;
        }
    }
}
